export default "__VITE_ASSET__CxWreR2G__"